import { SVGProps } from 'react';

const Bird = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16 7h.01M2 20 12.72 4.7A4 4 0 0 1 20 7v3a8 8 0 0 1-8 8H3.4M20 7l2 .5-2 .5M10 18v3m4-3.25V21m-7-3a6 6 0 0 0 3.84-10.61"
    />
  </svg>
);
export default Bird;
